import React from 'react'
import { Icon } from 'semantic-ui-react'
import cx from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { ToggleMenu } from '../../redux/actions/navbar'

import styles from './toggle-button.module.css'

const ToggleButton = () => {
  const dispatch = useDispatch()
  const toggle = useSelector((store) => store.navbar.toggleMenu)
  const toggleMenu = () => {
    dispatch(ToggleMenu())
  }
  return (
    <Icon
      style={{ margin: '8px' }}
      className={cx(styles.icon)}
      size="large"
      name={toggle ? 'arrow left' : 'bars'}
      inverted
      onClick={toggleMenu}
    />
  )
}

export default ToggleButton
